<template>
  <div id="app">
	<!-- <keep-alive  max="1" exclude="CommonAside">
		<router-view v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>
	<router-view v-if="!$route.meta.keepAlive" /> -->
<router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
	
  },
}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}

</style>
